import React from 'react';
import { motion } from 'framer-motion';
import { trackAddToCart } from '../../utils/metaPixel';
interface CTAButtonProps {
  className?: string;
  href?: string;
}
export function CTAButton({
  className = '',
  href
}: CTAButtonProps) {
  const scrollToOffer = (e: React.MouseEvent) => {
    e.preventDefault();
    const offerSection = document.getElementById('offer-section');
    if (offerSection) {
      offerSection.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };
  return <motion.a href={href || '#offer-section'} {...href ? {
    target: '_blank',
    rel: 'noopener noreferrer',
    onClick: () => trackAddToCart()
  } : {
    onClick: scrollToOffer
  }} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`
        inline-block w-full sm:w-auto px-8 py-4 md:py-5 
        bg-[#EA580C] hover:bg-[#C2410C] 
        text-white font-bold text-lg md:text-xl 
        rounded-full shadow-[0_8px_20px_rgba(234,88,12,0.3)] 
        hover:shadow-[0_12px_25px_rgba(234,88,12,0.4)]
        transition-all duration-300 ease-in-out
        font-['Nunito'] tracking-wide no-underline text-center
        ${className}
      `} data-id="element-199">
      ¡QUIERO MIS CENAS EN 15 MINUTOS AHORA!
    </motion.a>;
}